const styles = ':host{--sheet-size-small:30rem;--sheet-size-medium:45rem;--sheet-size-large:67.5rem;--border-outer:calc(max(var(--skapa-modal-align-start, 1) * var(--skapa-modal-rtl, 1), 0)*0.5rem);--border-inner:calc(max(-1 * var(--skapa-modal-align-start, 1) * var(--skapa-modal-rtl, 1), 0)*0.5rem);--border-for-side:var(--border-outer) var(--border-inner) var(--border-inner) var(--border-outer);--current-sheet-size:var(--sheet-size-medium);display:flex;flex-direction:column}:host([align-to-start]){--skapa-modal-align-start:-1;--skapa-modal-footer-alignment:flex-end}:host([skapa-rtl]){--skapa-modal-rtl:-1}:host([size=small]){--current-sheet-size:var(--sheet-size-small)}:host([size=large]){--current-sheet-size:var(--sheet-size-large)}:host:before{content:"";flex-grow:1;min-height:3rem;min-width:3rem}.modal{border-radius:.5rem .5rem 0 0;transform:translateY(100%)}.modal.visible{transition:transform var(--skapa-modal-transition-duration) var(--skapa-modal-transition-function)}:host([full-height]) .modal{flex-basis:100%}:host([preserve-alignment]){flex-direction:row}:host([preserve-alignment]):host:before{order:calc(2 + var(--skapa-modal-align-start, -2))}:host([preserve-alignment]) .modal{border-radius:var(--border-for-side);transform:translateX(calc(var(--skapa-modal-align-start, 1)*var(--skapa-modal-rtl, 1)*100%))}:host([open]) .modal.visible{transform:translate(0)!important}:host(:not([open])) .modal.visible{--null-if-startaligned:calc(var(--skapa-modal-align-start, 0) + 1);left:calc(var(--null-if-startaligned, 1)*var(--skapa-modal-rtl, 1)*var(--skapa-body-scrollbar-width, 0px));position:relative}slot[name=footer].skapa-empty{min-height:2rem}@media (min-width:37.5em){:host,:host([full-height]){flex-direction:row}:host .modal,:host([full-height]) .modal{border-radius:var(--border-for-side);flex-basis:var(--current-sheet-size);transform:translateX(calc(var(--skapa-modal-align-start, 1)*var(--skapa-modal-rtl, 1)*100%))}:host:before{order:calc(2 + var(--skapa-modal-align-start, -2))}}';
import { ModalAbstract } from "./ModalAbstract.js";
import { RTLObserver, SlotTools } from "@ingka/webc-tools";
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <div class="modal" part="wrapper">
      <slot name="header"></slot>
      <slot class="modal-body" role="document"></slot>
      <slot name="footer"></slot>
    </div>
  `;
  return { sheet: template };
}
class Sheet extends ModalAbstract {
  constructor() {
    super();
    this.handleSlotChange = (event) => {
      if (event.target) {
        const target = event.target;
        if (target.name === "footer")
          this.updateAssignedFooter();
      }
    };
    this.updateAssignedFooter = () => {
      const footer = this.querySelector(this.getPrefixedTagName("modal-footer"));
      if (footer) {
        footer.toggleAttribute("small", this.size === "small");
        footer.toggleAttribute("auto-size", this.size === "large");
      }
    };
    const templates = this.getTemplates(generateTemplate);
    this.shadowRoot.append(templates.sheet.content.cloneNode(true));
    this.gatherProperties(
      ["size", "fullHeight", "alignToStart", "preserveAlignment"],
      this
    );
  }
  connectedCallback() {
    super.connectedCallback();
    RTLObserver.addTarget(this, true);
    Array.from(this.shadowRoot.querySelectorAll("slot")).map(
      SlotTools.checkSlot
    );
    this.shadowRoot.addEventListener("slotchange", SlotTools.slotChange);
    this.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    this.updateAssignedFooter();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    RTLObserver.removeTarget(this);
    this.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
    this.shadowRoot.removeEventListener("slotchange", SlotTools.slotChange);
  }
  get size() {
    return this.getAttribute("size") || null || "medium";
  }
  set size(size) {
    if (size === "medium")
      this.removeAttribute("size");
    else
      this.setAttribute("size", size);
  }
  get fullHeight() {
    return this.hasAttribute("full-height");
  }
  set fullHeight(toggle) {
    this.toggleAttribute("full-height", !!toggle);
  }
  get alignToStart() {
    return this.hasAttribute("align-to-start");
  }
  set alignToStart(toggle) {
    this.toggleAttribute("align-to-start", !!toggle);
  }
  get preserveAlignment() {
    return this.hasAttribute("preserve-alignment");
  }
  set preserveAlignment(toggle) {
    this.toggleAttribute("preserve-alignment", !!toggle);
  }
  attributeChangedCallback(name, oldVal, newVal) {
    super.attributeChangedCallback(name, oldVal, newVal);
    if (name === "size") {
      this.updateAssignedFooter();
    }
  }
}
Sheet.skapaTagName = "sheet";
Sheet.skapaDependencies = [...ModalAbstract.skapaDependencies];
Sheet.observedAttributes = [
  ...ModalAbstract.observedAttributes,
  "size",
  "full-height"
];
export {
  Sheet
};
